<template>
<div>
<DataApp></DataApp>

</div>
</template>

<script>
import DataApp from "../../components/Applicant/DataApp.vue";


export default {
  components: {
   DataApp
  },
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  created() {
  }
};
</script>

<style scoped>


</style>